import { defineMessages } from 'react-intl';

export default defineMessages({
    OOSSliceDatesPopupMessage: {
        id: 'customer.common.wizard.step.policychange.warning.OOSSliceDates',
        defaultMessage: 'Your policy change is an out-of-sequence transaction. There are future transaction(s) effective { OOSSliceDates }. Are you sure you want to continue?'
    },
});
